import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from './Icons';
const faqs = [{
  q: 'How fast can you come out?',
  a: 'We schedule quickly — often same week. Emergency calls get priority response.'
}, {
  q: 'Do you serve my area?',
  a: 'We cover all of Orange County — Orange, Anaheim Hills, Tustin, Irvine, Huntington Beach, and more.'
}, {
  q: 'Is the cleanup included?',
  a: "Yes. We haul everything away. You won't see a branch, leaf, or stump left behind."
}, {
  q: 'What if a tree falls at night?',
  a: 'Call us. Emergency service is available — day or night, weekday or weekend.'
}, {
  q: "How do I know it's safe?",
  a: 'We have years of experience, professional-grade equipment, and trained crew members. Your property is in good hands from the moment we arrive.'
}, {
  q: 'Can you handle really large trees?',
  a: 'Absolutely — small trees, large trees, palms, stumps — no job is too big or too small.'
}];
export const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-24 bg-offwhite" data-id="element-63">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-64">
        <div className="text-center mb-16" data-id="element-65">
          <h2 className="text-3xl md:text-5xl font-bold text-charcoal mb-6" data-id="element-66">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-4" data-id="element-67">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-68">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-69">
                <span className="font-bold text-lg text-charcoal" data-id="element-70">{faq.q}</span>
                <ChevronDownIcon className={`w-6 h-6 text-gray-400 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-71" />
              </button>
              <AnimatePresence data-id="element-72">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-73">
                    <div className="px-6 pb-5 text-gray-600 border-t border-gray-100 pt-4" data-id="element-74">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
};